import {
    useEffect,
    useState,
    useCallback,
    useContext
} from "react";

import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import {
    getDashboard,
    getLinks
} from "../services/shortLinkService";

import { createPortal }
    from "react-dom";

import { TokenContext }
    from "./tokenContext";

import { useAuth }
    from "./AuthContext";

import GlobalNavDrawer
    from "./GlobalNavDrawer";

import { logout }
    from "../utils/firebase";

import DashboardCards
    from "../components/DashboardCards";

import CreateLinkForm
    from "../components/CreateLinkForm";

import LinkTable
    from "../components/LinkTable";

import StatsModal
    from "../components/StatsModal";

import "./UrlShortenerAdmin.css";

import RecentActivityTable
    from "../components/RecentActivityTable";

import {
    RoleDenied,
    canManageWorkforceLinks,
    redirectToJobBankLogin,
    useJobBankRole
} from "./jobBankRole";


export default function UrlShortenerAdmin() {

    const { currentUser } =
    useAuth();
const { balance, setBalance } = useContext(TokenContext);
const { role, roleLoading } = useJobBankRole(currentUser);

const [loading, setLoading] =
    useState(true);

const [dashboard, setDashboard] =
    useState(null);

const [links, setLinks] =
    useState([]);

const [selectedCode,
       setSelectedCode] =
    useState(null);

const loadData =
    useCallback(
        async () => {

            if (!currentUser?.uid) {
                return;
            }

            try {

                const dashboardData =
                    await getDashboard(
                        currentUser
                    );

                const linkData =
                    await getLinks(
                        currentUser
                    );

                setDashboard(
                    dashboardData
                );

                setLinks(
                    linkData.links || []
                );

            }

            catch (err) {

                console.error(
                    err
                );

            }

            finally {

                setLoading(
                    false
                );

            }

        },
        [currentUser]
    );

    useEffect(() => {
      let isMounted = true;
  
      const fetchTokens = async () => {
        if (!currentUser?.uid) return;
  
        const userRef = doc(db, "users", currentUser.uid);
  
        try {
          const userDoc = await getDoc(userRef);
  
          if (userDoc.exists() && isMounted) {
            setBalance(userDoc.data().tokens ?? 0);
          }
        } catch (error) {
          console.error("Error fetching token count:", error);
        }
      };
  
      fetchTokens();
  
      return () => {
        isMounted = false;
      };
    }, [currentUser, setBalance]);

    useEffect(() => {

        if (
            currentUser &&
            !roleLoading &&
            canManageWorkforceLinks(role)
        ) {

            loadData();

        }

    }, [currentUser, roleLoading, role, loadData]);

    if (!currentUser) {
        redirectToJobBankLogin("/workforcelinks");
        return null;
    }

    if (roleLoading) {
        return (
            <div className="urlShortenerLoading">
                Checking Job Bank role...
            </div>
        );
    }

    if (!canManageWorkforceLinks(role)) {
        return (
            <RoleDenied
                title="Workforce Links Access Required"
                message="Only users with the Job Bank Role of Employer or Career Coach can manage Workforce Links."
            />
        );
    }

    if (loading) {

        return (
            <div className="urlShortenerLoading">
                Loading Workforce Links...
            </div>
        );

    }

    return (

        <div className="urlShortenerPage">

            <div className="profileHeader">

                <h1>
                    Workforce Links
                </h1>

                <p>
                    Create and manage
                    shortened URLs,
                    QR codes,
                    and click analytics.
                </p>

            </div>

            <DashboardCards
                dashboard={dashboard}
            />

            <CreateLinkForm
                currentUser={currentUser}
                refresh={loadData}
            />

            <LinkTable
                currentUser={currentUser}
                links={links}
                refresh={loadData}
                onViewStats={
                    setSelectedCode
                }
            />
            
            <RecentActivityTable
                currentUser={
                    currentUser
                }
            />
            {
                selectedCode &&
                (
                    <StatsModal
                        currentUser={
                            currentUser
                        }
                        code={
                            selectedCode
                        }
                        onClose={() =>
                            setSelectedCode(null)
                        }
                    />
                )
            }
            {
                createPortal(

                    <GlobalNavDrawer
                        hideCurrent
                        links={[

                            {
                                to: "/purchase",
                                label:
                                    `Tokens: ${balance}`
                            },

                            {
                                to: "/jobbank",
                                label:
                                    "Job Bank Home"
                            },

                            {
                                to: "/employer",
                                label:
                                    "Employer Profile"
                            },

                            {
                                to: "/workforcelinks",
                                label:
                                    "Workforce Links"
                            },

                            {
                                to: "/login",
                                label:
                                    "Logout",

                                onClick:
                                    async () => {

                                        await logout();

                                    }
                            }

                        ]}
                    />,

                    document.body

                )
            }
        </div>

    );
}